import { render, staticRenderFns } from "./RegisterPageSteps.vue?vue&type=template&id=26df944d&scoped=true&"
import script from "./RegisterPageSteps.vue?vue&type=script&lang=js&"
export * from "./RegisterPageSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26df944d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26df944d')) {
      api.createRecord('26df944d', component.options)
    } else {
      api.reload('26df944d', component.options)
    }
    module.hot.accept("./RegisterPageSteps.vue?vue&type=template&id=26df944d&scoped=true&", function () {
      api.rerender('26df944d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/components/RegisterPageSteps.vue"
export default component.exports